export default "__VITE_ASSET__CAf1uqKp__"